import { Text } from '@loadsmart/miranda-react'

import { LoadRateWrapper } from './LoadRate.styles'

export type LoadRateProps = {
  rate: string
  ratePerMile?: string
  providerRateId?: string
}

export function LoadRate({ rate, ratePerMile, providerRateId, ...props }: LoadRateProps) {
  return (
    <LoadRateWrapper {...props}>
      <Text variant="heading-md-bold">{rate}</Text>
      {ratePerMile && (
        <Text variant="body-sm">
          Rate per mile{' '}
          <Text variant="body-sm-bold" color="color-primary-60">
            {ratePerMile}
          </Text>
        </Text>
      )}
      {providerRateId && (
        <Text variant="body-sm">
          Carrier rate ID{' '}
          <Text variant="body-sm-bold" color="color-primary-60">
            {providerRateId}
          </Text>
        </Text>
      )}
    </LoadRateWrapper>
  )
}
